<template>
      <div class="about-us-page-container">
        <ThePractice />
        <!-- <Privacy class="hidden"/>
        <GeneralTermsConditions class="hidden" />
        <ReferralPractice class="hidden" /> -->
        <Location class="hidden" />
      </div>
</template>

<script>
// import Privacy from '../components/Privacy.vue';
import ThePractice from '../components/ThePractice.vue';
// import GeneralTermsConditions from '../components/GeneralTermsConditions.vue';
// import ReferralPractice from '../components/ReferralPractice.vue';
import Location from '../components/Location.vue';



export default {
  name: "AboutUs",
  components: {
    ThePractice,
    // Privacy,
    // GeneralTermsConditions,
    // ReferralPractice,
    Location
},
  mounted(){
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Over ons - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Over ons website Milad");
      this.$store.commit('updateActivePage', 'AboutUs')
  }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}

.about-us-page-container {
  margin-top: 130px;
}

@media (max-width: 768px) {
  .about-us-page-container {
    margin-top: 82px;
  }

}
</style>